import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=47cb941b"
import script from "./Notes.vue?vue&type=script&lang=ts"
export * from "./Notes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports